import { useState } from "react";
import { withTranslation } from "react-i18next";
import { usePage } from "@inertiajs/react";

import closeIcon from "/assets/close.svg";

import Modal from "/components/Modal";
import TextField from "/components/TextField";
import TextArea from "/components/TextArea";
import Checkbox from "/components/Checkbox";
import Button from "/components/Button";

export default withTranslation()(function ContactModal({
  t,
  isOpen,
  setIsOpen,
}) {
  const props = usePage().props;
  const { locale, info_links } = props;
  const handleClose = () => {
    setIsOpen(false);
    resetForm();
  };

  const handleSuccessModalClose = () => setIsSuccessModalOpen(false);

  const [modalData, setModalData] = useState({});
  const [errors, setErrors] = useState({});
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const resetForm = () => {
    setModalData({});
    setErrors({});
  };

  const setModalName = (value) => {
    setModalData(data => ({ ...data, name: value }));
  };
  const setModalCompany = (value) => {
    setModalData(data => ({ ...data, company: value }));
  };
  const setModalEmail = (value) => {
    setModalData(data => ({ ...data, email: value }));
  };
  const setModalDescription = (value) => {
    setModalData(data => ({ ...data, description: value }));
  };
  const setModalConsent = (value) => {
    setModalData(data => ({ ...data, consent: value }));
  };

  const handleSubmit = () => {
    fetch("/inquiries", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ authenticity_token: props.csrf_token, ...modalData }),
    }).then((response) => {
      if (!response.ok) throw response;

      handleClose();
      setIsSuccessModalOpen(true);
    }).catch(async (errorResponse) => {
      const data = await errorResponse.json();
      if (data.errors) {
        setErrors(data.errors);
      } else {
        console.error({ errorResponse });
      }
    });
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        className="contact-modal"
      >
        <div className="modal__cross" onClick={handleClose}><img src={closeIcon} /></div>
        <div className="modal__text">
          <form className="frm">
            <TextField
              label={t("projects.contactForm.name")}
              placeholder={t("projects.contactForm.namePlaceholder")}
              value={modalData.name}
              onChange={setModalName}
              errors={errors.name}
            />
            <TextField
              label={t("projects.contactForm.company")}
              placeholder={t("projects.contactForm.companyPlaceholder")}
              value={modalData.company}
              onChange={setModalCompany}
              errors={errors.company}
            />
            <TextField
              label={`${t("projects.contactForm.email")}*`}
              placeholder="example@mail.com"
              value={modalData.email}
              onChange={setModalEmail}
              errors={errors.email}
            />
            <TextArea
              label={t("projects.contactForm.description")}
              placeholder={t("projects.contactForm.descriptionPlaceholder")}
              className="contact-modal__textarea"
              value={modalData.description}
              onChange={setModalDescription}
              errors={errors.description}
            />
            <Checkbox
              value={modalData.consent}
              onChange={setModalConsent}
              errors={errors.consent}
            >
              {t("projects.contactForm.privacyPolicyConsent")} {info_links.privacy_policy ? (
                <a className="underlined" href={`/${locale}${info_links.privacy_policy.value}`} target="_blank">{t("projects.contactForm.privacyPolicyPart")}</a>
              ) : (
                t("projects.contactForm.privacyPolicyPart")
              )}
            </Checkbox>
          </form>
        </div>

        <div className="modal__actions">
          <Button onClick={handleSubmit} className="btn btn--dark">{t("projects.contact")}</Button>
        </div>
      </Modal>
      <Modal
        isOpen={isSuccessModalOpen}
        onClose={handleSuccessModalClose}
        className="contact-modal"
      >
        <div className="modal__cross" onClick={handleSuccessModalClose}><img src={closeIcon} /></div>
        <div className="modal__text">{t("projects.contactSuccess.text")}</div>
        <div className="modal__actions">
          <Button onClick={handleSuccessModalClose} className="btn btn--dark">{t("projects.contactSuccess.button")}</Button>
        </div>
      </Modal>
    </>
  );
});
